<template>    
<div v-if="missionPlanUiState">
  <v-menu v-model="showMenu" 
          :position-x="x"
          :position-y="y"
          absolute
          offset-y
    >
    <v-list subheader>
        <v-subheader>{{$t('Pilot.Tools.Title')}}<v-spacer /><v-icon>mdi-group</v-icon></v-subheader>                     
        <v-list-tile @click="showGlobalWaypoint()">                
          <v-list-tile-avatar><v-icon>mdi-map-marker-plus</v-icon></v-list-tile-avatar>
        <v-list-tile-title>{{$t('Admin.MissionPlanTemplate.Form.AddGlobalWaypoint')}}</v-list-tile-title>                
      </v-list-tile>                        
        <v-list-tile   @click="changeDrawMode('wpt')">                
          <v-list-tile-avatar><v-icon>mdi-map-marker-plus</v-icon></v-list-tile-avatar>
        <v-list-tile-title>{{$t('Admin.MissionPlanTemplate.Form.AddWaypoint')}}</v-list-tile-title>      
        <v-list-tile-action>
          <v-spacer />            
          <v-icon v-text="drawMode=='wpt'?'mdi-checkbox-marked':'mdi-checkbox-blank-outline'" />
        </v-list-tile-action>          
      </v-list-tile>    
      <v-list-tile   @click="changeDrawMode('step')">                
          <v-list-tile-avatar><v-icon>mdi-debug-step-into</v-icon></v-list-tile-avatar>
        <v-list-tile-title>{{$t('Admin.MissionPlanTemplate.Form.AddStep')}}</v-list-tile-title>                
        <v-list-tile-action>
          <v-spacer />            
          <v-icon v-text="drawMode=='step'?'mdi-checkbox-marked':'mdi-checkbox-blank-outline'" />
        </v-list-tile-action>          
      </v-list-tile>          
      <v-list-tile  :value="mapState.showMissionPlanValidation"  @click="$store.myActions.UI_TOGGLE_MISSIONPLAN_VALIDATION_VISIBILITY(uiid)">
        <v-list-tile-avatar>
          <v-switch class="py-2" hide-details :input-value="mapState.showMissionPlanValidation" ></v-switch>
        </v-list-tile-avatar>
        <v-list-tile-title>{{$t('Pilot.Glider.ShowMissionPlanValidation')}}</v-list-tile-title>
      </v-list-tile>                   
    </v-list>        
    <slot></slot>
  </v-menu>     
</div>
</template>
<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import { MissionPlanUiState } from '../../models/ui/MissionPlanUiState'

import { MapUiState } from '../../models/ui/MapUiState'
import { IMissionPlanWaypoint } from '@/models/iris/missionPlan/IMissionPlanWaypoint'

@Component({
  name: 'MapMissionPlanContextMenu',
  props:{
    uiid:{
        type: String,
        required: true
    },
    missionPlanStateUiid:{
        type: String,
        required: true
    }
  }
})
export default class MapMissionPlanContextMenu extends Vue {
    missionPlanStateUiid!:string
    uiid!:string
    showMenu = false
    x = 0
    y = 0

    get missionPlanUiState(){
      return this.$store.myGetters.uistatebyuiid(this.missionPlanStateUiid) as MissionPlanUiState
    }

    get isMissionPlanEditable() {
      return (this.mapState.typeUiid == 'detail' && this.$store.myGetters.isMissionPlanModuleVisible)  || this.uiid == 'MissionPlan'
    }

    get mapState(){
      return this.$store.myGetters.uistatebyuiid(this.uiid) as MapUiState
    }

    get drawMode() { return this.missionPlanUiState.drawMode } 
    set drawMode(value){ 
      //s'assure que les outils de mesure soit a null
      this.$store.myActions.UI_SET_MEASURETOOL('NONE')
      this.$nextTick(()=>{
        this.$store.myActions.UI_MISSIONPLAN_SET_DRAWMOD({uiid:this.missionPlanStateUiid,drawmode:value}) 
      })      
    }

    get showGlobalWpts() { return this.missionPlanUiState.showGlobalWpts }
    set showGlobalWpts(value){ this.$store.myActions.UI_MISSIONPLAN_SET_SHOW_GLOBALWPT({uiid:this.missionPlanStateUiid,show:value})}

    show (e:any) {
      e.preventDefault()
      this.showMenu = false
      this.x = e.clientX
      this.y = e.clientY
      this.$nextTick(() => {
        this.showMenu = true
      })
    }   
     
    showGlobalWaypoint() {      
      this.showGlobalWpts = true
    }

    changeDrawMode(mode:string){  
      this.cancelWaypoint()
      this.$nextTick(() => {this.drawMode= this.drawMode==mode?"":mode})     
    }

    cancelWaypoint() {
      this.missionPlanUiState.currentEditWpt = MissionPlanUiState.getDefaultWayPoint() 
      this.missionPlanUiState.hoverWptId = -1
    }  

    nextWptsId(){
      return this.missionPlanUiState.missionPlan.wpts.length > 0? (Math.max(...this.missionPlanUiState.missionPlan.wpts.map(i => i.id)) + 1):1
    }
        
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scope>

</style> 
